import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
let AllEdit = class AllEdit extends Vue {
    constructor() {
        super(...arguments);
        this.formData = [
            {
                key: '',
                type: 1,
                value: '',
                options: {
                    maxLength: 200,
                    placeholder: '请输入',
                },
            },
        ];
    }
    getPopupContainer(triggerNode) {
        return triggerNode.parentNode;
    }
    get GetList() {
        const type = [1, 2, 3, 4, 5, 6, 7];
        const arr = this.data.filter((d) => {
            if (type.includes(d.type)) {
                let f = d.type === 1 && d.options.noRepeat;
                if (!f) {
                    if (d.options.hasOwnProperty('options') &&
                        d.options.options &&
                        d.options.options.indexOf(';') > -1) {
                        d.options.options = d.options.options.split(';');
                    }
                    else if (Array.isArray(d.options.options)) {
                        d.options.options = d.options.options;
                    }
                    else {
                        d.options.options = [];
                    }
                    return d;
                }
            }
        });
        return arr;
    }
    filteredOptions(index) {
        return this.GetList.filter((o) => {
            let arr = this.formData.map((d) => d.key);
            arr = arr.filter((d) => d !== this.formData[index].key);
            return !arr.includes(o.key);
        });
    }
    mounted() {
        console.log(this.data);
    }
    addRows() {
        let flag = this.formData.every((d) => {
            return d.key && d.value;
        });
        if (!flag) {
            this.$message.warning('请先完善当前数据设置');
            return false;
        }
        this.formData.push({
            key: '',
            type: 1,
            value: '',
            options: {
                maxLength: 200,
                placeholder: '请输入',
            },
        });
    }
    delRows(index) {
        this.formData.splice(index, 1);
    }
    onHandleData(value, obj) {
        console.log(value, obj);
        if (value && obj.data.attrs) {
            const { index, type, options } = obj.data.attrs;
            this.formData[index].type = type;
            this.formData[index].value = undefined;
            this.formData[index].options = options;
        }
    }
    emits() {
        this.$emit('change', this.formData);
    }
};
tslib_1.__decorate([
    Prop()
], AllEdit.prototype, "data", void 0);
AllEdit = tslib_1.__decorate([
    Component({
        name: 'AllEdit',
        components: {
        // AButton: Button
        },
    })
], AllEdit);
export default AllEdit;
